import React, { useMemo } from 'react';
import cx from 'classnames';
import b1 from './images/b_1.png.js';
import b2 from './images/b_2.png.js';
import s1 from './images/s_1.png.js';
import s2 from './images/s_2.png.js';
import g1 from './images/g_1.png.js';
import g2 from './images/g_2.png.js';
import p1 from './images/p_1.png.js';
import p2 from './images/p_2.png.js';
import pe1 from './images/pe_1.png.js';
import pe2 from './images/pe_2.png.js';
import o1 from './images/o_1.png.js';
import o2 from './images/o_2.png.js';
import d1 from './images/d_1.png.js';
import d2 from './images/d_2.png.js';
import pa1 from './images/pa_1.png.js';
import pa2 from './images/pa_2.png.js';
import c1 from './images/c_1.png.js';
import c2 from './images/c_2.png.js';
import styles from './index.module.scss.js';

const mask = {
  bronze: {
    mask1: b1,
    mask2: b2
  },
  "bronze 1": {
    mask1: b1,
    mask2: b2
  },
  "bronze 2": {
    mask1: b1,
    mask2: b2
  },
  "bronze 3": {
    mask1: b1,
    mask2: b2
  },
  "bronze 4": {
    mask1: b1,
    mask2: b2
  },
  "bronze 5": {
    mask1: b1,
    mask2: b2
  },
  bronze5: {
    mask1: b1,
    mask2: b2
  },
  silver: {
    mask1: s1,
    mask2: s2
  },
  "silver 1": {
    mask1: s1,
    mask2: s2
  },
  "silver 2": {
    mask1: s1,
    mask2: s2
  },
  "silver 3": {
    mask1: s1,
    mask2: s2
  },
  "silver 4": {
    mask1: s1,
    mask2: s2
  },
  "silver 5": {
    mask1: s1,
    mask2: s2
  },
  gold: {
    mask1: g1,
    mask2: g2
  },
  "gold 1": {
    mask1: g1,
    mask2: g2
  },
  "gold 2": {
    mask1: g1,
    mask2: g2
  },
  "gold 3": {
    mask1: g1,
    mask2: g2
  },
  "gold 4": {
    mask1: g1,
    mask2: g2
  },
  "gold 5": {
    mask1: g1,
    mask2: g2
  },
  platinum: {
    mask1: p1,
    mask2: p2
  },
  "platinum 1": {
    mask1: p1,
    mask2: p2
  },
  "platinum 2": {
    mask1: p1,
    mask2: p2
  },
  "platinum 3": {
    mask1: p1,
    mask2: p2
  },
  "platinum 4": {
    mask1: p1,
    mask2: p2
  },
  "platinum 5": {
    mask1: p1,
    mask2: p2
  },
  pearl: {
    mask1: pe1,
    mask2: pe2
  },
  "pearl 1": {
    mask1: pe1,
    mask2: pe2
  },
  "pearl 2": {
    mask1: pe1,
    mask2: pe2
  },
  "pearl 3": {
    mask1: pe1,
    mask2: pe2
  },
  "pearl 4": {
    mask1: pe1,
    mask2: pe2
  },
  "pearl 5": {
    mask1: pe1,
    mask2: pe2
  },
  onyx: {
    mask1: o1,
    mask2: o2
  },
  "onyx 1": {
    mask1: o1,
    mask2: o2
  },
  "onyx 2": {
    mask1: o1,
    mask2: o2
  },
  "onyx 3": {
    mask1: o1,
    mask2: o2
  },
  "onyx 4": {
    mask1: o1,
    mask2: o2
  },
  "onyx 5": {
    mask1: o1,
    mask2: o2
  },
  diamond: {
    mask1: d1,
    mask2: d2
  },
  "diamond 1": {
    mask1: d1,
    mask2: d2
  },
  "diamond 2": {
    mask1: d1,
    mask2: d2
  },
  "diamond 3": {
    mask1: d1,
    mask2: d2
  },
  "diamond 4": {
    mask1: d1,
    mask2: d2
  },
  "diamond 5": {
    mask1: d1,
    mask2: d2
  },
  palladium: {
    mask1: pa1,
    mask2: pa2
  },
  "palladium 1": {
    mask1: pa1,
    mask2: pa2
  },
  "palladium 2": {
    mask1: pa1,
    mask2: pa2
  },
  "palladium 3": {
    mask1: pa1,
    mask2: pa2
  },
  "palladium 4": {
    mask1: pa1,
    mask2: pa2
  },
  "palladium 5": {
    mask1: pa1,
    mask2: pa2
  },
  castle: {
    mask1: c1,
    mask2: c2
  },
  "castle 1": {
    mask1: c1,
    mask2: c2
  },
  "castle 2": {
    mask1: c1,
    mask2: c2
  },
  "castle 3": {
    mask1: c1,
    mask2: c2
  },
  "castle 4": {
    mask1: c1,
    mask2: c2
  },
  "castle 5": {
    mask1: c1,
    mask2: c2
  }
  // 'magic eye': {
  //   mask1: m1,
  //   mask2: m2,
  // },
};
const RewardIconWrapper = ({
  icon,
  className,
  style,
  children,
  ...props
}) => {
  const iconName = useMemo(
    () => icon && icon?.toLowerCase()?.replace(/[0-9\s]/g, "") || "",
    [icon]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles[iconName]]: !!iconName
      }),
      "data-icon": iconName,
      "data-vip-icon-wrapper": true,
      style,
      ...props
    },
    children,
    mask[iconName]?.mask1 && /* @__PURE__ */ React.createElement(
      "img",
      {
        className: styles["mask-1"],
        src: mask[iconName]?.mask1,
        alt: "mask 1"
      }
    ),
    mask[iconName]?.mask2 && /* @__PURE__ */ React.createElement(
      "img",
      {
        className: styles["mask-2"],
        src: mask[iconName]?.mask2,
        alt: "mask 2"
      }
    )
  );
};
RewardIconWrapper.displayName = "RewardIconWrapper";

export { RewardIconWrapper };
//# sourceMappingURL=index.js.map
